module.exports = __webpack_public_path__ + "img/JX11X5.png";